import { Input } from 'legacy/lut/library/inputs'
import { useCallback } from 'react'

import { useDebouncedEffect } from 'core-components/hooks/useDebounced'

import { TRANSLATION_KEYS } from '../../translations'

import { IGlobalPartnerSearchProps } from './models/globalPartnerSearchProps'

import styles from './GlobalPartnerSearch.module.scss'

export const GlobalPartnerSearch = ({
  setSearchValueToCrudFilters,
  searchValue,
  updateSearchValue,
}: IGlobalPartnerSearchProps) => {
  const fetchGlobalPartnersDebouncedCallback = useCallback(() => {
    setSearchValueToCrudFilters(searchValue)
  }, [searchValue, setSearchValueToCrudFilters])

  useDebouncedEffect(fetchGlobalPartnersDebouncedCallback, 500, [searchValue])

  return (
    <Input
      endContent={<i className={'kbase kbase-search'} />}
      type="search"
      translation={TRANSLATION_KEYS.globalPartnerSearchText}
      value={searchValue}
      onChange={updateSearchValue}
      classes={{
        root: styles.globalPartnerSearchInput,
      }}
    />
  )
}
